<template>
  <div class="systemParam column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div class="width300">
          <el-input placeholder="参数名称" style="width: 100%;" clearable v-model="searchName"></el-input>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left20" @click="clickClear">清空</div>
      </div>
      <div class="margin-top30">
        <el-table :data="tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style">
          <el-table-column prop="name" label="参数名称" align="center"></el-table-column>
          <el-table-column prop="value" label="参数值" align="center">
            <template v-slot="scope">
              <div v-if="scope.row.type==='地址'">
                {{ scope.row.province + scope.row.city + scope.row.region + scope.row.address }}
                &nbsp;{{ scope.row.userName + scope.row.phone }}
              </div>
              <div v-else>{{ scope.row.value }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="分类" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="250" v-if="canOperate">
            <template v-slot="scope">
              <div class="row-me center-all">
                <div class="btn-blue width100 btn-height40" @click="clickEdit(scope.row)">
                  <el-icon>
                    <edit/>
                  </el-icon>
                  修改
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="margin-top20">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>

    </div>

    <!-- 弹窗 -->
    <el-dialog title="编辑参数" v-model="visible" width="45%" top="10vh" :destroy-on-close="true">
      <div class="main-content">
        <div class="row-me row-center">
          <div>参数名：</div>
          <div class="margin-left10">{{ selectItem.name }}</div>
        </div>
        <div class="row-me margin-top30" v-if="selectItem.type==='数值'">
          <div>参数值：</div>
          <div class="margin-left10 width500">
            <el-input placeholder="请输入" style="width: 100%;" clearable
                      v-model="selectItem.value"></el-input>
          </div>
        </div>
        <div class="row-me margin-top30" v-if="selectItem.type==='文本'">
          <div>参数值：</div>
          <div class="margin-left10 width500">
            <el-input placeholder="请输入" type="textarea" style="width: 100%;" clearable rows="5"
                      v-model="selectItem.value"></el-input>
          </div>
        </div>
        <div class="row-me margin-top30" v-if="selectItem.type==='开关'">
          <div>参数值：</div>
          <div class="margin-left10 width500">
            <el-switch v-model="selectItem.checked" active-text="是" inactive-text="否"/>
          </div>
        </div>
        <div class="row-me margin-top30" v-if="selectItem.type==='地址'">
          <div>参数值：</div>
          <div class="flex1">
            <div class="row-me row-center">
              <div class="flex1">
                <el-select v-model="selectItem.province" placeholder="请选择省" style="width: 100%;" filterable
                           clearable @change="provinceChange">
                  <el-option v-for="item in provinceArray" :key="item.id" :label="item.n"
                             :value="item.n">
                  </el-option>
                </el-select>
              </div>
              <div class="flex1 margin-left10">
                <el-select v-model="selectItem.city" placeholder="请选择市" style="width: 100%;" filterable
                           clearable @change="cityChange">
                  <el-option v-for="item in cityArray" :key="item.id" :label="item.n" :value="item.n">
                  </el-option>
                </el-select>
              </div>
              <div class="flex1 margin-left10">
                <el-select v-model="selectItem.region" placeholder="请选择区/县" style="width: 100%;" filterable
                           clearable>
                  <el-option v-for="item in areaArray" :key="item.id" :label="item.n" :value="item.n">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="flex1 margin-top20">
              <el-input placeholder="请输入详细地址" style="width: 100%;" clearable
                        v-model="selectItem.address" maxlength="50"></el-input>
            </div>
            <div class="margin-top30" style="color: #949494;">寄件人信息：</div>
            <div class="flex1 margin-top20">
              <el-input placeholder="请输入寄件人姓名" style="width: 100%;" clearable
                        v-model="selectItem.userName"></el-input>
            </div>
            <div class="flex1 margin-top20">
              <el-input placeholder="请输入电话号码" style="width: 100%;" clearable
                        @input="selectItem.phone=this.$method.checkInput(selectItem.phone,0)"
                        v-model="selectItem.phone"></el-input>
            </div>
          </div>
        </div>
        <div class="row-me row-center flex-end1 margin-top200">
          <div class="btn-blue width110 btn-height40" @click="clickOk">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cityData from '../../assets/js/citys.js'

export default {
  components: {},
  data() {
    return {
      searchName: '',
      tableData: [],
      visible: false,
      selectItem: {},
      pageNo: 1,
      total: 0,
      provinceArray: [],
      cityArray: [],
      areaArray: [],
      canOperate: false,
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.provinceArray = cityData
    this.clickSearch()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    provinceChange(e) {
      this.selectItem.city = ''
      this.selectItem.region = ''
      this.cityArray = []
      this.areaArray = []
      if (e && e !== '') {
        for (let i = 0; i < this.provinceArray.length; i++) {
          let item = this.provinceArray[i]
          if (e === item.n) {
            this.cityArray = item.c
          }
        }
      }
    },
    cityChange(e) {
      this.selectItem.region = ''
      this.areaArray = []
      if (e && e !== '') {
        for (let i = 0; i < this.cityArray.length; i++) {
          let item = this.cityArray[i]
          if (e === item.n) {
            this.areaArray = item.c
          }
        }
      }
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //查询
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      this.searchName = ''
      this.clickSearch()
    },
    //修改
    clickEdit(item) {
      item.checked = item.value === '是'
      this.selectItem = this.$method.deepClone(item)
      this.visible = true
    },
    //确定
    clickOk() {
      if (this.selectItem.type === '数值' || this.selectItem.type === '文本') {
        if (this.$method.isEmpty(this.selectItem.value)) {
          this.$message.error("请输入参数值")
          return
        }
      } else if (this.selectItem.type === '开关') {
        this.selectItem.value = this.selectItem.checked ? '是' : '否'
      } else if (this.selectItem.type === '地址') {
        if (this.$method.isEmpty(this.selectItem.province)) {
          this.$message.error("请选择省")
          return
        }
        if (this.$method.isEmpty(this.selectItem.city)) {
          this.$message.error("请选择市")
          return
        }
        if (this.$method.isEmpty(this.selectItem.region)) {
          this.$message.error("请选择区/县")
          return
        }
        if (this.$method.isEmpty(this.selectItem.address)) {
          this.$message.error("请输入详细地址")
          return
        }
        if (this.$method.isEmpty(this.selectItem.userName)) {
          this.$message.error("请输入寄件人姓名")
          return
        }
        if (this.$method.isEmpty(this.selectItem.phone)) {
          this.$message.error("请输入电话号码")
          return
        }
      }
      this.$postRequest('/admin/systemConfig/updateParameter', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visible = false
          this.clickSearch()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/systemConfig/findSystemMechList', {
        pageNumber: this.pageNo,
        name: this.searchName,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.systemParam {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }

  .main-content {
    padding: 10px 20px;
  }
}
</style>
